import { render, staticRenderFns } from "./protocolList.vue?vue&type=template&id=54b3d4f2"
import script from "./protocolList.vue?vue&type=script&lang=ts"
export * from "./protocolList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports